import {
  AlignmentType,
  Document,
  HeadingLevel,
  Packer,
  Paragraph,
  TabStopPosition,
  TabStopType,
  TextRun,
  BorderStyle,
  Table,
  TableCell,
  TableRow,
  VerticalAlign,
  WidthType,
} from 'docx';
import { GridFieldSummary } from '~/models/modules/gridField';

export class DocumentCreator {

  public createGrid(title: string, items: any[], gridColumns: GridFieldSummary[]): Document {
    const activeColumns = gridColumns.filter(gc => gc.selected);
    const activeColumnsKeyArray: string[][] = [];

    const tableHeaderCells: TableCell[] = [];

    activeColumns.forEach(ac => {
      tableHeaderCells.push(new TableCell({
        children: [
          new Paragraph({
            children: [
              new TextRun({
                text: ac.title,
                bold: true
              })
            ]
          })
        ],
        verticalAlign: VerticalAlign.CENTER
      }))

      activeColumnsKeyArray.push(ac.field.split("."));
    });

    const tableRows: TableRow[] = [new TableRow({
      children: tableHeaderCells
    })];

    items.forEach(item => {
      const rowCells: TableCell[] = [];

      activeColumns.forEach((ac, i) => {
        let text: string;
        if (item[ac.field] !== undefined && item[ac.field] !== null) {
          text = item[ac.field];
        } else {
          switch(activeColumnsKeyArray[i].length){
            case 1:
              text = item[activeColumnsKeyArray[i][0]];
              break;
            case 2:
              if (Array.isArray(item[activeColumnsKeyArray[i][0]])) {
                text = (item[activeColumnsKeyArray[i][0]] && item[activeColumnsKeyArray[i][0]][0]) ? item[activeColumnsKeyArray[i][0]][0][activeColumnsKeyArray[i][1]] : null;
              }
              else {
                text = item[activeColumnsKeyArray[i][0]] ? item[activeColumnsKeyArray[i][0]][activeColumnsKeyArray[i][1]] : null;
              }
              break;
            case 3:
              if (Array.isArray(item[activeColumnsKeyArray[i][0]])) {
                if(!item[activeColumnsKeyArray[i][0]] || item[activeColumnsKeyArray[i][0]].length == 0){
                  text = null;
                }else{
                  text = (item[activeColumnsKeyArray[i][0]][0] && item[activeColumnsKeyArray[i][0]][0][activeColumnsKeyArray[i][1]]) ? item[activeColumnsKeyArray[i][0]][0][activeColumnsKeyArray[i][1]][activeColumnsKeyArray[i][2]] : null;
                }

              }
              else {
                text = (item[activeColumnsKeyArray[i][0]] && item[activeColumnsKeyArray[i][0]][activeColumnsKeyArray[i][1]]) ? item[activeColumnsKeyArray[i][0]][activeColumnsKeyArray[i][1]][activeColumnsKeyArray[i][2]] : null;
              }
              break;
          }
        }

        rowCells.push(new TableCell({
          children: [
            new Paragraph({
              text: text?.toString()
            })
          ],
          verticalAlign: VerticalAlign.CENTER
        }))
      });

      tableRows.push(new TableRow({
        children: rowCells,
      }))
    });
    const document = new Document({
      sections: [
        {
          children: [
            new Paragraph({
              text: title,
              heading: HeadingLevel.TITLE,
              alignment: AlignmentType.CENTER,
            }),
            new Table({
              rows: tableRows,
              alignment: AlignmentType.CENTER,
              width: { size: 100, type: WidthType.PERCENTAGE },
            })
          ]
        }
      ]
    });
    return document;
  }
}
